const SectionVerifyEmail = Class(
	/**
	 * @lends {SectionVerifyEmail#}
	 */
	{
		bodyClass: 'small-nav',

		__construct: function () {
			this.node = mkE({
				tag: 'div',
				id: 'sign-up',
				className: 'container'
			});
		},

		route: function(){
			let part = this.url.shift();
			if( part === 'invalid' ){
				return new SectionVerifyEmail.Invalid();
			}
			if( !D.ID ){
				Section.navigate(D.url('/'), {
					popState: true
				});
				return false;
			}
			if( part === 'empty' ){
				return new SectionVerifyEmail.Empty();
			}
		},

		draw: function() {
			this.node.append(this.layout.ct());
			this._left = mkE({
				tag: 'div',
				className: 'left verify-email',
				els: [
					{
						tag: 'h1',
						className: 'h2',
						text: D.Lang.get('sign-up.verify.title')
					},
					{
						tag: 'p',
						els: [
							D.Lang.get('sign-up.verify.caption'),
							{
								tag: 'br',
							},
							{
								tag: 'br',
							},
							D.Lang.get('sign-up.verify.no_link'),
							{
								tag: 'br',
							},
							{
								tag: 'a',
								onclick: this._resend,
								text: D.Lang.get('sign-up.verify.resend')
							}
						]
					}
				]
			}).append(this.node);
			this._right = mkE({
				tag: 'div',
				className: 'right'
			}).append(this.node);
			this.ready();
		},

		_resend: function(){
			if( this._isSending ){
				return;
			}
			this._isSending = true;
			if (this._removeTimeout) {
				clearTimeout(this._removeTimeout);
			}
			this._removeSuccess();
			new RPC('/api/web_rpc.php').send('resendVerify', {}, this._onResend);
		},

		_onResend: function(){
			this._isSending = false;
			this._successNode = mkE({
				tag: 'div',
				className: 'email-success',
				text: D.Lang.get('email-verify.email-sent')
			}).append(this._left);
			this._removeTimeout = setTimeout(this._removeSuccess, 10000);
		},

		_removeSuccess() {
			if (!this._successNode) {
				return;
			}
			this._successNode.remove();
		}
	},
	Section
);

SectionVerifyEmail.Invalid = Class(
	/**
	 * @lends {SectionVerifyEmail.Invalid#}
	 */
	{

		route: function(){
		},

		draw: function() {
			this.node.append(this.layout.ct());
			this._left = mkE({
				tag: 'div',
				className: 'left verify-email',
				els: [
					{
						tag: 'h1',
						className: 'h2',
						text: D.Lang.get('sign-up.verify.invalid.title')
					},
					{
						tag: 'p',
						els: [
							D.Lang.get('sign-up.verify.invalid.caption'),
							{
								tag: 'br',
							},
							{
								tag: 'br',
							},
							{
								tag: 'a',
								href: D.url('sign-in'),
								text: D.Lang.get('sign-up.verify.invalid.login')
							},
							' ' + D.Lang.get('sign-up.verify.invalid.login_caption')
						]
					}
				]
			}).append(this.node);
			this._right = mkE({
				tag: 'div',
				className: 'right'
			}).append(this.node);
			this.ready();
		},
	},
	SectionVerifyEmail
);

SectionVerifyEmail.Empty = Class(
	/**
	 * @lends {SectionVerifyEmail.Empty#}
	 */
	{
		bodyClass: 'small-nav',

		__construct: function () {
			this.node = mkE({
				tag: 'div',
				id: 'sign-up',
				className: 'container'
			});
		},

		route: function(){
		},

		draw: function() {
			this.node.append(this.layout.ct());
			this._left = mkE({
				tag: 'div',
				className: 'left'
			}).append(this.node);
			this._right = mkE({
				tag: 'div',
				className: 'right'
			}).append(this.node);
			new SectionVerifyEmail.Empty.Form().append(this._left);
			this.ready();
		},
	},
	Section
);

SectionVerifyEmail.Empty.Form = Class(
	/**
	 * @lends {SectionVerifyEmail.Empty.Form#}
	 */
	{
		_fields: {},

		__construct: function(){
			this.node = mkE({
				tag: 'div',
				className: 'sign-up-form password-recovery',
				els: [
					{
						tag: 'div',
						className: 'top',
						els: [
							{
								tag: 'div',
								className: 'left',
								els: [
									{
										tag: 'h1',
										className: 'h2',
										text: D.Lang.get('sign-up.nomail.title')
									},
									this._caption = mkE({
										tag: 'div',
										className: 'caption',
										text: D.Lang.get('sign-up.nomail.caption')
									})
								]
							}
						]
					}
				]
			});

			this._drawForm();
		},

		_drawForm: function(){
			this._form = mkE({
				tag: 'form',
				className: 'form',
				prop: {
					onsubmit: this._submit
				}
			}).append(this.node);

			mkE({
				tag: 'div',
				className: 'row',
				els: [
					this._fields['email'] = new T.Form.Input({
						caption: D.Lang.get('sign-up.nomail.email'),
						type: 'email'
					})
				]
			}).append(this._form);

			mkE({
				tag: 'div',
				className: 'row bottom',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							{
								tag: 'button',
								className: 'button button-pink',
								text: D.Lang.get('sign-up.nomail.submit'),
								onclick: this._submit
							}
						]
					}
				]
			}).append(this._form);
		},

		_submit: function(){
			if( this._isSubmitting ){
				return false;
			}
			if( this._errorNode ){
				this._errorNode.remove();
			}
			let data = {};
			let hasError = false;
			for( let field in this._fields ){
				if( !this._fields.hasOwnProperty(field) ){
					continue;
				}
				this._fields[field].error(null);
				if( !this._fields[field].value() ){
					hasError = true;
					this._fields[field].error(D.Lang.get('sign-up.errors.empty'))
				}
				data[field] = this._fields[field].value();
			}
			if( hasError ){
				return false;
			}
			this._isSubmitting = true;
			new RPC('/api/web_rpc.php').send('setMail', data, this._onSubmit);
			return false;
		},

		_onSubmit: function(re){
			if( empty(re) ){
				this._errorNode = T.error(D.Lang.get('sign-up.errors.general'), true).prepend(this._form);
				return;
			}
			if( re.ok ){
				Section.navigate(D.url('/verify-email'), {
					popState: true
				});
				return;
			}
			this._isSubmitting = false;
			if( !empty(re.error) ){
				if( typeof re.error === 'object' ){
					for( let field in re.error ){
						if( !re.error.hasOwnProperty(field) ){
							continue;
						}
						this._fields[field].error(D.Lang.get('sign-up.errors.' + field + '.' + re.error[field]));
					}
				}else{
					this._errorNode = T.error(D.Lang.get('sign-up.errors.general'), true).prepend(this._form);
				}
			}
		}
	},
	mkE.Base
);
